import angular from 'angular';
import npsSurvey from './npsSurvey';
import './style.scss';

export default angular
  .module('components.npsSurvey', [])
  .component('npsSurvey', npsSurvey).name;
